import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { CircleNotch } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;

    if (!sid) {
      toast.error("Missing Google session. Please try signing in again.");
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await http.post("/auth/google/session", { session_id: sid });
        // Clear the hash so it isn't reprocessed on refresh
        try { window.history.replaceState(null, "", window.location.pathname); } catch {}
        await refresh();
        toast.success(`Welcome, ${data.user?.full_name?.split(" ")[0] || "investor"}!`);
        const to = data.user?.role === "admin" ? "/admin" : "/dashboard";
        nav(to, { replace: true });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Google sign-in failed.";
        toast.error(msg);
        nav("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-[#f8fafc]">
      <div className="text-center">
        <CircleNotch size={48} className="mx-auto text-[#00b4d8] animate-spin" weight="bold" />
        <p className="mt-4 font-display font-bold text-[#0a1128] text-lg">Signing you in…</p>
        <p className="text-sm text-slate-500 mt-1">Finalising your Google authentication.</p>
      </div>
    </div>
  );
}
